<template xmlns="http://www.w3.org/1999/html">
  <drag-drawer v-model="showDrawer"
               :width.sync="width"
               :min-width="minWidth"
               :inner="true"
               :transfer="false"
               :placement="placementComputed"
               :draggable="true"
               :mask="false"
               :mask-closable="false"
               @on-resize="handleResize"
               @on-visible-change="handleClose"
               :scrollable="true">
    <div slot="header">
      <div style="display: flex">
        <img :src="icon" class="top-icon"/><label style="padding-top: 7px;margin-left: 3px;"><!--<el-icon :class="model.icon" style="color: #3da8f1"></el-icon>--> {{ model ? model.name:''}}</label>
      </div>

    </div>
    <!--名称-->
    <div class="param">
      <label style="width: 10%"><span style="color: red;">*</span>名&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
      <el-input v-if="model != null" :value="model.label" size="small" style="width: 80%;" @input="changeNodeName"></el-input>
    </div>
    <div class="param" v-if="!showType[3]">
      <label style="width: 10%">&nbsp;&nbsp;关注点：</label>
      <el-input v-model="scene.rsFocus" size="small" style="width: 80%;" placeholder="请输入关注内容"></el-input>
    </div>

    <!--label1-->
    <div class="label_line">
      {{label1}}
    </div>
    <!--动作 http节点不显示-->
    <div class="param" v-show="!showType[2]">
      <div v-show="showType[1] || showType[0] || showType[3]">
        <template
          v-for="(action,index) in actionList">
          <div :key="`action`+index" style="margin-bottom: 10px">
            <!--action-->
            <el-select
              v-model="action.rsaType"
              size="small"
              @change="changeAction(index)"
              style="width: 40%"
              placeholder="请选择">
              <el-option
                v-for="item in voiceActions"
                :key="`itemAction`+item.action"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <!--file-->
            <el-select
              size="small"
              style="width: 40%"
              v-show="action.rsaType!==2"
              v-model="action.rsaPlayFile"
              @change="changeFile"
              placeholder="请选择">
              <el-option
                v-for="param in fileList"
                :key="`param`+param.id"
                :label="param.name"
                :value="param.id">
              </el-option>
            </el-select>
            <!--word-->
            <el-input size="small" style="width: 40%" v-model="action.rsaPlayTxt" v-show="action.rsaType===2" :maxlength="1024" placeholder="请输入文字"></el-input>
            <i class="el-icon-delete" style="cursor: pointer" @click.prevent="deleteAction(action)"></i>
          </div>
        </template>
        <a @click="addAction" class="param">+新增动作</a>
      </div>

      <div v-show="showType[1]">
        <div class="param">
          <label style="width: 10%">返回值：</label>
          <el-autocomplete
            placeholder="输入$自动提示"
            :fetch-suggestions="querySearch"
            :trigger-on-focus="false"
            v-model="dtmf.respVName"
            @select="handleSelectDTMFReturn"
            size="small"
            style="width: 75%"></el-autocomplete>
        </div>
        <div class="param">
          <label style="width: 12%">收号长度：</label>
          <el-input v-model="dtmf.length" size="small" style="width: 72%;" placeholder="请输入"></el-input>
        </div>
        <div class="param">
          <label style="width: 10%">结束符：</label>
          <el-select
            v-model="dtmf.terminator"
            size="small"
            style="width: 20%"
            placeholder="请选择"
          >
            <el-option
              v-for="ss in dtmfSymbols"
              :key="`dtmfSymbols`+ss.id"
              :label="ss.value"
              :value="ss.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>

    <!--http 交互-->
    <div class="param" v-show="showType[2]">
      <div class="param">
        <label style="width: 20%;">URL地址：</label>
        <el-input v-model="httpData.url" size="small" style="width: 75%" placeholder="请输入"></el-input>
      </div>
      <div class="param">
        <label style="width:20%;margin-left: 26px">方法：</label>
        <el-select
          v-model="httpData.method"
          size="small"
          style="width: 75%"
          placeholder="请选择"
          @change="changeMethod"
        >
          <el-option
            v-for="method in httpMethods"
            :key="`method`+method.id"
            :label="method.label"
            :value="method.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="param">
        <label style="width:20%;">返回参数：</label>
        <el-autocomplete
          placeholder="输入$自动提示"
          :fetch-suggestions="querySearch"
          :trigger-on-focus="false"
          v-model="httpData.receivedName"
          @select="handleSelectHTTPReturn"
          size="small"
          style="width: 75%"></el-autocomplete>
      </div>
      <!--请求参数提示-->
      <div class="paramTip">
        <p>Header是请求头</p>
        <p>Query是指请求的参数，一般是拼接在URL中的，用于GET方法</p>
        <p>Body是值请求体数据</p>
      </div>
      <!--tab 表格-->
      <div class="param">
        <Tabs v-model="activeName" @on-click="handleTabClick">
          <!--query tab-->
          <TabPane label="Query" name="Query">
            <div style="margin: 10px 0px">
              <el-table
                :data="httpData.queries"
                border
                tooltip-effect="light"
                style="width: 100%">
                <el-table-column
                  label="名称">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.name" placeholder="参数名"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="值">
                  <template slot-scope="scope">
                    <!--<el-autocomplete
                      v-model="scope.row.value"
                      placeholder="输入$自动提示"
                      :fetch-suggestions="querySearch2"
                      :trigger-on-focus="false"
                      @select="handleSelectHttp"
                    ></el-autocomplete>-->
                    <el-input v-model="scope.row.value" placeholder="参数值">
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  width="60"
                  label="操作">
                  <template slot-scope="scope">
                    <el-button icon="el-icon-delete" @click="handleDeleteQuery(scope.$index,scope.row)" circle style="color: #3da8f1"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <a @click="addHttpQuery" class="param">+新增参数</a>
            </div>
          </TabPane>
          <!--header tab-->
          <TabPane label="Header" name="Header">
            <div style="margin: 10px 0px">
              <el-table
                :data="httpData.headers"
                border
                tooltip-effect="light"
                style="width: 100%">
                <el-table-column
                  label="名称">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.name" placeholder="参数名"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="值">
                  <template slot-scope="scope">
                    <!--<el-autocomplete
                      v-model="scope.row.value"
                      placeholder="输入$自动提示"
                      :fetch-suggestions="querySearch2"
                      :trigger-on-focus="false"
                      @select="handleSelectHttp"
                    ></el-autocomplete>-->
                    <el-input v-model="scope.row.value" placeholder="参数值">
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  width="60"
                  label="操作">
                  <template slot-scope="scope">
                    <el-button icon="el-icon-delete" @click="handleDeleteHeader(scope.$index,scope.row)" circle style="color: #3da8f1"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <a @click="addHttpHeader" class="param">+新增参数</a>
            </div>
          </TabPane>
          <!--body tab-->
          <TabPane label="Body" name="Body">
            <!--<el-autocomplete
              type="textarea"
              v-model="httpData.bodies[0].body"
              placeholder="输入$自动提示"
              :fetch-suggestions="querySearch2"
              :trigger-on-focus="false"
              style="width: 100%"
              :rows="5"
              :autosize="{minRows:5,maxRows:5}"
              @select="handleSelectHttpBody">
            </el-autocomplete>-->
            <el-input
              type="textarea"
              v-model="httpData.bodies[0].body"
              placeholder="参数值，json格式"
              style="width: 100%"
              :rows="5"
              :autosize="{minRows:5,maxRows:5}"
            >
            </el-input>
          </TabPane>
        </Tabs>
      </div>
    </div>

    <!--label2-->
    <div class="label_line">
      {{label2}}
      <Poptip placement="top" transfer width="220" word-wrap :content="tips" trigger="hover">
        <img :src="questionMark" class="tip-img" v-show="!showType[3]"/>
      </Poptip>
      <!--连线自动添加-->
      <!--<el-button :disabled="true" v-show="showType[2] || showType[1]" size="mini" style="float: right;color: #3da8f1;margin-top: 3px;" @click="addCondition">+新增条件分支</el-button>-->
    </div>
    <!--条件分支设置-->
    <div class="param" v-show="showType[2] || showType[1]">
      <template v-for="(branch,index) in branchs">
        <el-divider :key="`fdivider`+index" v-show="index!==0"></el-divider>
        <div :key="`branch`+index">
          <label style="width: 30%">如果满足条件</label>
          <el-input v-model="branch.name" style="width: 65%" size="small" @input="changeJudgeLabel(branch)"></el-input>
          <i class="el-icon-delete" style="cursor: pointer" @click.prevent="deleteCondition(branch)"></i>
        </div>
        <template v-for="(or,oindex) in branch.or">
          <div :key="`or`+oindex+`|`+index" style="background-color: #DCDFE6;padding-top: 10px;margin-top: 10px;padding-bottom: 10px;margin-bottom: 10px">
            <template v-for="(and,aindex) in or.ands">
              <div :key="`and`+aindex" class="param">
                <el-autocomplete
                  v-model="and.rCondition"
                  placeholder="输入$自动提示"
                  size="small"
                  style="width: 35%"
                  :fetch-suggestions="querySearch2"
                  :trigger-on-focus="false"
                  @select="handleSelectHttp"
                ></el-autocomplete>
                <!--选择符号-->
                <!--符号-->
                <el-select
                  size="small"
                  style="width: 20%"
                  v-model="and.rSymbol"
                  placeholder="请选择">
                  <el-option
                    v-for="symbol in symbols"
                    :key="`symbol`+symbol.id"
                    :title="symbol.label"
                    :label="symbol.label"
                    :value="symbol.value">
                  </el-option>
                </el-select>
                <!--具体的值-->
                <el-input v-model="and.rValue" size="small" placeholder="请输入具体的值" style="width: 35%"></el-input>
                <i class="el-icon-delete" style="cursor: pointer" @click.prevent="deleteAnd(index,oindex,and)"></i>
              </div>
            </template>
            <div class="param">
              <a @click="addAnd(index,oindex)">+新增（AND）条件</a>
              <i class="el-icon-delete" style="cursor: pointer;float: right;margin-right: 40px" @click.prevent="deleteOr(index,or)"></i>
            </div>
          </div>
          <div :key="`ldivider`+oindex+`|`+index">
           <Divider dashed orientation="center">Or</Divider>
          </div>
        </template>
        <a :key="`addOr`+index" @click="addOr(index)">+新增（OR）条件</a>
      </template>
    </div>
    <!--意图识别-->
    <div class="param" v-show="showType[0]">
      <template v-for="(item,index) in triggerList">
        <div :key="`indent`+index" style="margin-bottom: 10px">
          <!--识别关键-->
          <el-select
            size="small"
            style="width: 20%"
            v-model="item.trigger"
            @change="changeTrigger"
            placeholder="请选择">
            <el-option
              v-for="trigger in triggers"
              :key="`trigger`+trigger.type"
              :label="trigger.label"
              :value="trigger.value">
            </el-option>
          </el-select>
          <!--符号-->
          <el-select
            size="small"
            style="width: 15%"
            v-model="item.symbol"
            @change="changeSymbol"
            placeholder="请选择"
            :disabled="item.trigger===1"
          >
            <el-option
              v-for="symbol in symbols"
              :key="`symbol2`+symbol.id"
              :label="symbol.label"
              :value="symbol.value">
            </el-option>
          </el-select>
          <!--<el-input v-model="item.symbol" size="small" style="width: 9%;" :disabled="item.trigger==1"></el-input>-->
          <!--意图或者参数-->
          <!--意图-->
          <el-select
            size="small"
            style="width: 21%"
            v-model="item.purposeId"
            @change="changeIndent(item)"
            @visible-change="updateHasIndent"
          >
            <el-option
              v-for="indent in indentList"
              :key="`sindent`+indent.id"
              :disabled="indent.disabled"
              :label="indent.name"
              :value="indent.id">
            </el-option>
          </el-select>
          <!--箭头-->
          <el-input value="-->" size="small" style="width: 9%;" :disabled="true"></el-input>
          <!--next scene-->
          <el-select
            size="small"
            style="width: 21%"
            v-model="item.nextSceneId"
            :disabled="true"
            @change="changeNextScene">
            <el-option
              v-for="node in nodes"
              :key="`node`+node.id"
              :label="node.name"
              :value="node.nodeId">
            </el-option>
          </el-select>
          <!--delete trigger-->
          <i class="el-icon-delete" style="cursor: pointer" @click.prevent="deleteTrigger(item)"></i>
        </div>
      </template>
      <!--新增trigger-->
      <!--自动添加-->
      <!--<a @click="addTrigger" :disabled="true" class="param">+新增触发条件</a>-->
    </div>
    <!--结束动作-->
    <div class="param" v-show="showType[3]">
      <template
        v-for="(action,index) in endActionList">
        <div :key="`eaction`+index" style="margin-bottom: 10px">
          <!--action-->
          <el-select
            v-model="action.eaType"
            size="small"
            @change="changeEndAction(index)"
            style="width: 40%"
            placeholder="请选择">
            <el-option
              v-for="item in endActions"
              :key="`eitemAction`+item.action"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!--file-->
          <el-select
            size="small"
            style="width: 40%"
            v-show="action.eaType!==3 && action.eaType !== 1"
            v-model="action.eaValue"
            @change="changeFile"
            placeholder="请选择">
            <el-option
              v-for="param in action.actionParams"
              :key="`eparam`+param.id"
              :label="param.name"
              :value="param.value">
            </el-option>
          </el-select>
          <!--word-->
          <el-input size="small" style="width: 40%" v-model="action.eaValue" v-show="action.eaType===3 && action.eaType!==1" placeholder="请输入号码"></el-input>
          <!--<i class="el-icon-delete" style="cursor: pointer" @click.prevent="deleteEndAction(action)"></i>-->
        </div>
      </template>
      <!--<a @click="addEndAction" class="param">+新增动作</a>-->
    </div>


    <!--label3-->
    <div class="label_line" v-show="!showType[3]">
      {{label3}}
    </div>

    <!--不满足条件设置-->
    <div class="param" v-show="showType[2] || showType[1]">
      <div>
        <label>如果不满足以上所有条件</label>
        <el-select
          v-model="othersNextSceneId"
          size="small"
          placeholder="请选择"
        >
          <el-option
            v-for="select in nodes"
            :key="`condition`+select.id"
            :label="select.name"
            :value="select.nodeId"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <!--参数设置-->
    <div class="param" v-show="showType[0]">
      <!--提示文本-->
      <div class="paramTip">
        <p>若反问文案需要引用到对话中收集到的参数时，请使用统一格式：xxxx：${意图名称.参数名称}</p>
      </div>
      <!--意图选择-->
      <div class="param">
        <span>选择意图：</span>
        <el-select
          size="small"
          style="width: 65%"
          v-model="indentId"
          @change="changeParamIndent"
          placeholder="请选择"
        >
          <el-option
            v-for="indent in nodeIndentList"
            :key="`sin`+indent.id"
            :label="indent.name"
            :value="indent.id">
          </el-option>
        </el-select>
      </div>
      <!--参数表格-->
      <div class="param">
        <el-table
          :data="paramList"
          border
          tooltip-effect="light"
          style="width: 100%">
          <el-table-column
            width="50"
            label="必填">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.required" :true-label="1" :false-label="0" @change="changeRequired(scope.row)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            property="name"
            :show-overflow-tooltip="true"
            label="参数名称">
          </el-table-column>
          <el-table-column
            property="showNounName"
            :show-overflow-tooltip="true"
            label="使用的识别能力">
          </el-table-column>
          <el-table-column
            width="60"
            label="反问话术">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" @click="handleAsk(scope.$index,scope.row)" circle style="color: #3da8f1"></el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
    </div>

    <!--footer 语音交互显示-->
    <div slot="footer" v-if="showType[0]">
      <div style="display: flow">
        <div style="width: 20%;float: left">
          <el-checkbox v-model="scene.rsInterrupt" :true-label="1" :false-label="0" style="margin-top: 5px">可打断</el-checkbox>
        </div>
        <div style="width: 60%;float: left">
          超时（秒）：
          <el-input size="small" style="width: 150px" type="number" v-model="scene.rsOverTime" placeholder="请输入超时时间(秒)"></el-input>
        </div>
      </div>
    </div>

    <!--dialog-->
    <AskDialog :askId="askId" :askData="askData" :fileList="askFile" :show="showDialog" @close="closeDialog" @updateParams="updateParam"></AskDialog>
  </drag-drawer>
</template>

<script>
    import DragDrawer from "./dragDrawer/drag-drawer";
    import {publicFunClass} from "@/components/js/PublicFunClass.js"
    import {uniqueId} from "../../../util";
    import AskDialog from "./AskDialog";
    import eventBus from "../../../util/eventBus";

    export default {
      name: "NodeDrawer",
      components: {AskDialog, DragDrawer},
      props: ['nodeShow', 'flowId','model','nodeList'],
      mixins: [publicFunClass],
      data() {
        return {
          width: 500,
          minWidth: 500,
          placement: 'right',
          showDrawer: false,
          questionMark:require('../../../assets/image/homeAsk.png'),
          screenHeight:{height:''},
          icon:undefined,
          label:undefined,
          label1:'动作设置',
          label2:'识别设置',
          tips:'连接节点，自动添加意图识别',
          label3:'信息采集槽位',
          actionList:[],
          endActionList:[{id:'',rsId:this.sceneId,eaType:1,eaValue:'',actionParams:[]}],
          voiceActions:[
            {action:'playFile',label:'播放文件',value:1},
            {action:'playTTS',label:'播放文字',value:2}
          ],//语音交互动作集合
          endActions:[
            {action:'hangup',label:'挂机',value:1},
            {action: 'transferQueue',label: '转技能组',value: 2},
            {action:'transferCall',label:'转呼',value:3},
            {action: 'transferIVR',label: '转IVR',value: 4}
          ],//结束节点动作交互集合
          /*actionParams:[
            {id:1,name:'无敌'},
            {id:2,name:'发如雪'}
          ],*///动作参数
          fileList:[],//语音文件集合
          IVRList:[],//ivr号码集合
          queueList:[],//队列集合
          triggerList:[],//触发数据
          triggers:[
            {type:'indent',label:'意图',value:1},
            /*{type:'nonu',label:'专有名词',value:2}*/
          ],//触发方式
          indentList:[],//该流程下的全部意图
          //意图下拉时更新
          nodeIndentList:[],//该节点所持有的意图
          /*nodeList:[
            {id:1,label:'询问姓名',name:'询问姓名'},
            {id:2,label:'未知场景',name:'未知场景'}
          ],//节点（场景）*/
          nodes:[],
          paramList:[],//意图参数列表，根据意图获取
          indentId:'',//参数意图
          httpMethods:[
            {id:0,value:0,label:'GET'},
            {id:1,value:1,label:'POST'}
          ],
          httpData:{id:'',method:'',url:'',othersNextSceneId:'',received:'',receivedName:'',headers:[],bodies:[{id:'',rsId:'',body:''}],queries:[]},
          activeName:'Query',//当前激活的tab页
          autoCompleteData:[],//自动完成得数据,即全局变量，意图参数(暂无)
          autoCompleteDataAll:[],

          symbols:[
            {id:1,label:'==',value:'=='},
            {id:2,label:'!=',value:'!='},
            {id:3,label:'>=',value:'>='},
            {id:4,label:'<=',value:'<='},
            {id:5,label:'>',value:'>'},
            {id:6,label:'<',value:'<'},
            {id:7,label:'Contains',value:'Contains'},
            {id:8,label:'NotContains',value:'NotContains'},
            {id:9,label:'StringContains',value:'StringContains'},
            {id:10,label:'IsNull',value:'IsNull'},
            {id:11,label:'IsNotNull',value:'IsNotNull'}
          ],
          /*overTime:[
            {id:1,label:'30秒',value:30},
            {id:2,label:'40秒',value:40},
            {id:3,label:'60秒',value:60},
            {id:4,label:'90秒',value:90},
            {id:5,label:'120秒',value:120},
            {id:6,label:'180秒',value:180},
            {id:7,label:'240秒',value:240}
          ],*/
          dtmf:{
            id:'',
            rsId:'',
            respVId:'',
            respVName:'',
            length:'',
            terminator:'#',
            othersNextSceneId:''
          },
          othersNextSceneId: '',
          dtmfSymbols:[{value:'#',id:1},{value: '$',id:2}],
          showType:[true,false,false,false],
          branchs:[/*{
            name:'条件分支-',
            id:'',
            nextSceneId:'',
            or:[{
              ands:[
                {
                  id:'',
                  rJudgeId:'',
                  rCondition:'',
                  rSymbol:'',
                  rValue:'',
                }
              ]
            }]
          }*/],//DTMF,HTTP 条件设置数据
          conditionsOtherSelect:[{id:1,value:1,label:'转人工',name:'转人工'}],
          askId:'',
          showDialog:false,
          scene:{rsInterrupt: 0,id:'',rsType:'1',rsName:'',rwId:'',isFirstNode:'0',rsOverTime:30,rsFocus:''},
          sceneId:'',
          askData:[],
          askFile:[],
          //删除的数据
          deleteActions:[],
          deleteRecognizes:[],
          deleteAnds:[],
          deleteOrs:[],
          deleteBranches:[],
          deleteHeaders:[],
          deleteQueries:[],
          slotList:[],//查询出来不做操作，当改变必须，或者反问数据时添加进来
        }
      },
      methods: {
        async initSelectData(flowId) {
          //初始化所有的下拉等数据
          //语音文件
          let that = this
          let fileParam = {rwId:flowId}
          let res = await this.$http.post('/AI/voiceFiles',fileParam)
          let response = res.data
          if (response.flag != '666') {
            that.$alert(response.msg,'提示',{
              confirmButtonText: '确定'
            })
            return false
          }
          this.fileList = response.obj
          //所有的意图
          let res2 = await this.$http.post('/AI/indents',fileParam)
          let response2 = res2.data
          if (response2.flag !== '666') {
            console.log('load indents error',response2.msg)
            return
          }
          this.indentList = response2.obj
          if (this.indentList.length > 0) {
            this.indentList.forEach(i=>{
              i.disabled = false
            })
          }
          //队列
          let res3 = await this.$http.post('/AI/queues',fileParam)
          let response3 = res3.data
          if (response3.flag !== '666') {
            console.log('load queues error',response3.msg)
            return
          }
          this.queueList = response3.obj
          //ivr
          let res4 = await this.$http.post('/AI/ivrs',fileParam)
          let response4 = res4.data
          if (response4.flag !== '666') {
            console.log('load ivrs error',response4.msg)
            return
          }
          this.IVRList = response4.obj
          //autoComplete
          let res5 = await this.$http.post('/AI/FlowDetail/queryGlobalVariables',fileParam)
          let response5 = res5.data
          if (response5.flag !== '666') {
            console.log('load global error',response5.msg)
            return
          }
          let autos = response5.obj
          if (autos.length > 0) {
            this.autoCompleteData = []
            autos.forEach(auto=>{
              auto.value = '${global.'+auto.vName+'}'
              this.autoCompleteData.push(auto)
            })
          }

          let res6 = await this.$http.post('/AI/paramAutoComplete',fileParam)
          let response6 = res6.data
          if (response6.flag !== '666') {
            console.log('load global error',response6.msg)
            return
          }
          let auto = response6.obj
          if (auto.length > 0) {
            this.autoCompleteDataAll = []
            auto.forEach(auto=>{
              auto.value = auto.name
              this.autoCompleteDataAll.push(auto)
            })
          }
          //node
          //由上一级传过来（可能包含新建的节点）
        },
        /*initNodeData(sceneId,indentId) {
          let param = {type:'0',sceneId:sceneId,indentId:indentId}
          this.$http.post('/AI/node/detail',param).then(res=>{
            let response = res.data
            if (response.flag !== '666') {
              console.log('load node detail data error',response.msg)
              this.$message.error('加载节点数据出错')
              return
            }
            //拼装数据
            this.generatorData(response.obj)
          })
        },*/
        generatorData(data) {
          if (data.deleteActions) {
            //记录删除的值
            this.deleteActions = data.deleteActions
            this.deleteAnds = data.deleteAnds
            this.deleteBranches = data.deleteBranches
            this.deleteHeaders = data.deleteHeaders
            this.deleteQueries = data.deleteQueries
          }
          if (data.deleteRecognizes) {
            this.deleteRecognizes = data.deleteRecognizes
          }
          if (data.deleteOrs){
            this.deleteOrs = data.deleteOrs
          }
          let that = this;
          //基本数据
          this.scene = data.scene
          switch (this.scene.rsType+'') {
            case '1':
              //语音节点
              // {id:1,action:1,paramId:1,word:'123',actionParams:[]}
              let actionArr = []
              let actions = data.actions
              if (actions.length > 0) {
                actions.forEach(action=>{
                  action.actionParams = that.fileList
                  actionArr.push(action)
                })
                that.actionList = actionArr
              }
              //识别
              // {id:1,trigger:1,symbol:'==',purposeId:1,nextSceneId:1}
              let recognizes = data.recognizes
              let recArr = []
              if (recognizes.length > 0) {
                this.indentId = recognizes[0].purposeId
                recognizes.forEach(rec=>{
                  let json = {}
                  json.id = rec.id
                  json.rsId = rec.rsId
                  json.trigger = 1
                  json.symbol = '=='
                  json.purposeId = rec.purposeId
                  json.nextSceneId = rec.nextSceneId
                  recArr.push(json)
                })
                this.triggerList = recArr

                this.nodeIndentList = []
                this.triggerList.forEach(t=>{
                  this.indentList.forEach(i=>{
                    if (t.purposeId === i.id) {
                      let json = {}
                      json.id = t.purposeId
                      json.name = i.name
                      this.nodeIndentList.push(json)
                    }
                  })
                })
              }
              //params
              this.slotList = data.params
              if (this.indentId) {
                this.changeParamIndent(this.indentId);
              }
              break;
            case '2':
              //action
              let actionArr2 = []
              let actions2 = data.actions
              if (actions2.length > 0) {
                actions2.forEach(action=>{
                  action.actionParams = that.fileList
                  actionArr2.push(action)
                })
                that.actionList = actionArr2
              }
              //dtmf
              Object.assign(this.dtmf,data.dtmf)
              let respVId = this.dtmf.respVId
              if (this.autoCompleteData.length > 0) {
                this.autoCompleteData.forEach(a=>{
                  if (a.id === respVId) {
                    this.dtmf.respVName = a.value
                  }
                })
              }
              this.othersNextSceneId = this.dtmf.othersNextSceneId
              if (this.othersNextSceneId === 'null') {
                this.othersNextSceneId = ''
              }
              //judge
              let judges = data.judges;
              if (judges.length > 0) {
                /*judges.forEach(j=>{
                  j.name = j.edgeLabel
                })*/
                this.branchs = judges
              }
              break;
            case '3':
              //节点
              Object.assign(this.httpData,data.http)
              let bodies = data.http.bodies
              if (bodies.length <= 0) {
                this.httpData.bodies.push({id:'',rsId:'',body:''})
              }
              if (this.httpData.received) {
                if (this.autoCompleteData.length > 0) {
                  this.autoCompleteData.forEach(a=>{
                    if (a.id === that.httpData.received) {
                      that.httpData.receivedName = a.value
                    }
                  })
                }
              }
              //judges
              this.othersNextSceneId = this.httpData.othersNextSceneId
              if (this.othersNextSceneId === 'null') {
                this.othersNextSceneId = ''
              }
              //judge
              //conditions:{other:1,branchs:[{name:'条件分支-',or:[{and:[{param:'',symbol:'',value:''}]}]}}
              let httpJudges = data.judges
              if (httpJudges.length > 0) {
                /*httpJudges.forEach(j=>{
                  j.name = j.name
                })*/
                this.branchs = httpJudges
              }
              break;
            case '4':
              //end节点
              //只有动作
              //action
              let actionArr3 = []
              let actions3 = data.actions
              if (actions3.length > 0) {
                actions3.forEach(action=>{
                  action.actionParams = that.fileList
                  actionArr3.push(action)
                })
                that.actionList = actionArr3
              }
              // {id:1,action:1,paramId:1,word:'123',actionParams:[]}
              let arr3 = []
              let endAction = data.endActions
              if (endAction.length > 0) {
                endAction.forEach(action=>{
                  let type = action.eaType + ''
                  //action.eaValue += ''
                  if (type === '2') {
                    action.actionParams = that.queueList
                  }else if (type === '4') {
                    action.actionParams = that.IVRList
                  }
                  arr3.push(action)
                })
                that.endActionList = arr3
              }
              break
          }
        },
        generatorUpdateData() {
          //当属性框改变显示的时候，或者节点变化的时候，把该个节点属性提交到父组件存储
          //生成更新的数据
          let json = {}
          if (this.scene) {
            //基本数据
            json.scene = this.scene
            //
            json.deleteActions = this.deleteActions
            json.deleteRecognizes = this.deleteRecognizes
            json.deleteOrs = this.deleteOrs
            json.deleteAnds = this.deleteAnds
            json.deleteBranches = this.deleteBranches
            json.deleteHeaders = this.deleteHeaders
            json.deleteQueries = this.deleteQueries
            switch (this.scene.rsType+'') {
              case "1":
                json.actions = this.actionList
                json.params = this.slotList
                json.recognizes = this.triggerList
                break
              case '2':
                json.dtmf = this.dtmf
                json.dtmf.othersNextSceneId = this.othersNextSceneId
                json.actions = this.actionList
                json.judges = this.branchs
                break
              case '3':
                json.http = this.httpData
                json.judges = this.branchs
                json.http.othersNextSceneId = this.othersNextSceneId
                break
              case '4':
                json.actions = this.actionList
                json.endActions = this.endActionList
                break
            }
          }
          this.$emit('updateData',json)
        },
        resetData() {
          this.dtmf = {
            id:'',
            rsId:'',
            respVId:'',
            respVName:'',
            length:'',
            terminator:'#',
            othersNextSceneId:''
          }
          this.httpData = {id:'',method:'',url:'',othersNextSceneId:'',received:'',receivedName:'',headers:[],bodies:[{id:'',rsId:'',body:''}],queries:[]}
          this.actionList = []
          this.endActionList = [{id:'',rsId:this.sceneId,eaType:1,eaValue:'',actionParams:[]}]
          this.triggerList = []
          this.branchs = [/*{
            name:'条件分支-',
            id:'',
            nextSceneId:'',
            or:[{
              ands:[
              ]
            }]
          }*/],//DTMF,HTTP 条件设置数据
          //删除数据集合
          this.scene={rsInterrupt: 0,id:'',rsType:'1',rsName:'',rwId:'',isFirstNode:'0',rsOverTime:30,rsFocus:''}
          this.deleteActions = []
          this.deleteRecognizes = []
          this.deleteOrs = []
          this.deleteAnds = []
          this.deleteBranches = []
          this.deleteHeaders = []
          this.deleteQueries = []
          this.slotList = []
          this.indentId = ''
          this.sceneId = ''
          this.askId = ''
          this.paramList = []
        },
        updateHasIndent(val) {
          let that = this
          if (!val) {
            if (this.triggerList.length <= 0) {
              this.nodeIndentList = [];
              this.indentId = ''
            } else {
              if (this.indentList.length > 0) {
                this.nodeIndentList = []
                this.triggerList.forEach(t=>{
                  this.indentList.forEach(i=>{
                    if (t.purposeId === i.id) {
                      let json = {}
                      json.id = t.purposeId
                      json.name = i.name
                      this.nodeIndentList.push(json)
                    }
                  })
                });
                let id = ''
                if (this.nodeIndentList.length > 0) {
                  this.nodeIndentList.forEach(n=>{
                    if (n.id === that.indentId) {
                      id = that.indentId
                    }
                  })
                }
                this.indentId = id
              }
            }
            if (this.indentId == "") {
              this.paramList = []
            }
          }
        },
        handleResize(event) {
          const {atMin} = event
        },
        handleClose(val) {
          if (!val) {
            this.generatorUpdateData()
            this.$emit('closeNodeDrawer', true)
          }
        },
        changeNodeName(value) {
          this.$emit('updateNodeLabel',this.model.id,value)
          this.scene.rsName = value
        },
        changeAction(index) {
          //修改参数为下标行号
          let action = this.actionList[index].rsaType
          this.actionList[index].rsaPlayFile = ''
          /*if (action === 1) {
          }else if (action === 2) {
          }*/
        },
        changeEndAction(index) {
          let action = this.endActionList[index].eaType
          this.endActionList[index].eaValue = ''
          if (action === 1) {
            this.endActionList.splice(index+1)
          }else if (action === 2) {
            this.endActionList[index].actionParams = this.queueList
          }else if (action === 3) {
          }else if (action === 4) {
            this.endActionList[index].actionParams = this.IVRList
          }
        },
        changeFile(file) {

        },
        addAction() {
          /*if (this.actionList.length > 0) {
            let action = this.actionList[this.actionList.length - 1]
            if (action.action === 5) {
              return
            }
          }*/
          this.actionList.push({id:'',rsaSeq:'',rsId:this.sceneId,rsaType:1,rsaPlayFile:'',rsaPlayTxt: '',key:Date.now()});
        },
        addEndAction() {
          if (this.endActionList.length > 0) {
            let action = this.endActionList[this.endActionList.length - 1]
            if (action.eaType === 1) {
              return
            }
          }
          this.endActionList.push({id:'',rsId:this.sceneId,eaType:1,eaValue:'',key:Date.now(),actionParams:[]});
        },
        deleteAction(action) {
          let index = this.actionList.indexOf(action)
          if (index !== -1) {
            if (action.id) {
              this.deleteActions.push(action.id+'');
            }
            this.actionList.splice(index, 1)
          }
        },
        deleteEndAction(action) {
          let index = this.endActionList.indexOf(action)
          if (index !== -1) {
            if (action.id) {
              this.deleteActions.push(action.id+'')
            }
            this.endActionList.splice(index, 1);
          }
        },
        changeTrigger(trigger) {
        },
        changeSymbol(symbol) {

        },
        changeIndent(indent) {
          if (this.triggerList.length > 0 && this.indentList.length > 0) {
            this.indentList.forEach(i=>{
              i.disabled = false
              if (indent.purposeId === i.id) {
                this.$emit('updateRecognizeLabel',indent,i)
              }
            })
            this.triggerList.forEach(t => {
              this.indentList.forEach(i => {
                if (t.purposeId === i.id) {
                  i.disabled = true;
                }
              })
            });
          }
        },
        changeJudgeLabel(judge) {
          this.$emit('updateJudgeLabel',judge)
        },
        changeParamIndent(indent) {
          let param = {sceneId: this.scene.id, indentId: indent}
          this.paramList = []
          this.$http.post('/AI/queryIndentSlots',param).then(res=>{
            let response = res.data
            if (response.flag !== '666') {
              console.log("load slots error ",response.msg)
              return
            }
            let params = response.obj
            if (params.length > 0) {
              params.forEach(param=>{
                this.slotList.forEach(slot=>{
                  if (param.rsId === slot.rsId && param.paramId === slot.paramId) {
                    param = slot
                  }
                })
                param.showNounName = '@'+param.nounName
                this.paramList.push(param)
              })
            }
          })
        },
        changeNextScene(nextScene) {

        },
        addTrigger() {
          if (this.triggerList.length > 0 && this.indentList.length > 0) {
            this.indentList.forEach(i=>{
              i.disabled = false
            })
            this.triggerList.forEach(t => {
              this.indentList.forEach(i => {
                if (t.purposeId === i.id) {
                  i.disabled = true
                }
              })
            });
          }
          this.triggerList.push({
            id:'',
            trigger:1,
            symbol:'==',
            purposeId:'',
            nextSceneId:'',
            key:Date.now()
          });
        },
        deleteTrigger(trigger) {
          let temp = {}
          $.extend(true,temp,trigger)
          let index = this.triggerList.indexOf(trigger)
          //let temp = JSON.parse(JSON.stringify(trigger))

          if (index > -1) {
            if (this.indentList.length > 0) {
              this.indentList.forEach(i=>{
                if (i.id === trigger.purposeId) {
                  i.disabled = false
                }
              })
            }
            if (temp.id) {
              this.deleteRecognizes.push(temp.id+'')
            }
            this.triggerList.splice(index, 1);
            this.$emit('deleteRecognize',trigger)
          }
        },
        handleAsk(index,row) {
          this.showDialog = true
          this.askId = row.id
          this.askData = []
          this.askData.push(row)
          this.askFile = this.fileList
        },
        updateParam(param) {
          let item = param[0]
          if (item) {
            let slot = this.slotList.find(slot=>{
              return slot.rpId === item.rpId && slot.paramId === item.paramId
            })
            let index = this.slotList.indexOf(slot);
            if (index > -1) {
              this.slotList.splice(index, 1);
            }
            this.slotList.push(item);
          }
        },
        changeRequired(item) {
          if (item.id) {
            this.slotList.push(item);
          } else {
            if (item.required === 1) {
              this.slotList.push(item);
            } else {
              item.required = 0
              let index = this.slotList.indexOf(item)
              if (index > -1) {
                this.slotList.splice(index, 1)
              }
            }
          }
        },
        querySearch(queryString, cb) {
          if (queryString.endsWith('$')) {
            cb(this.autoCompleteData);
          } else {
            cb([])
          }
        },
        querySearch2(queryString, cb) {
          if (queryString.endsWith('$')) {
            cb(this.autoCompleteDataAll);
          } else {
            cb([])
          }
        },
        handleSelectDTMFReturn(item){
          //DTMF选择返回参数
          if (this.autoCompleteData.length > 0) {
            this.dtmf.respVId = ''
            this.autoCompleteData.forEach(a=>{
              if (a === item) {
                this.dtmf.respVId = a.id
              }
            })
          }
        },
        handleSelectHTTPReturn(item) {
          if (this.autoCompleteData.length > 0) {
            this.httpData.received = ''
            this.autoCompleteData.forEach(a=>{
              if (a === item) {
                this.httpData.received = a.id
              }
            })
          }
        },
        changeMethod(method) {

        },
        handleTabClick(tabName) {

        },
        addHttpQuery() {
          this.httpData.queries.push({id:'',rsId:'',name:'',value: ''})
        },
        addHttpHeader() {
          this.httpData.headers.push({id:'',rsId:'',name:'',value: ''})
        },
        handleDeleteQuery(index, row) {
          if (this.httpData.queries.length > index) {
            if (row.id) {
              this.deleteQueries.push(row.id+'')
            }
            this.httpData.queries.splice(index,1);
          }
        },
        handleDeleteHeader(index, row) {
          if (this.httpData.headers.length > index) {
            if (row.id) {
              this.deleteHeaders.push(row.id+'')
            }
            this.httpData.headers.splice(index,1);
          }
        },
        handleSelectHttp(item) {
        },
        handleSelectHttpBody(item) {
          this.httpBodies = this.httpBodies + item.value
        },
        addCondition() {
          this.branchs.push({
            name:'条件分支-'+uniqueId(),
            key:Date.now(),
            or:[
              {
                ands:[],
                id:'',
                branchId:'',
              }
            ]
          })
        },
        addAnd(index,oindex) {
          this.branchs[index].or[oindex].ands.push({
            id:'',
            rJudgeId:'',
            rCondition:'',
            rSymbol:'',
            rValue:'',
            key:Date.now()
          })
        },
        addOr(index) {
          this.branchs[index].or.push({
            ands:[],
            id:'',
            branchId:'',
            key:Date.now()
          })
        },
        deleteAnd(index,oindex,and) {
          let aindex = this.branchs[index].or[oindex].ands.indexOf(and)
          if (aindex > -1) {
            if (and.id) {
              this.deleteAnds.push(and.id+'')
            }
            this.branchs[index].or[oindex].ands.splice(aindex,1);
          }
        },
        deleteOr(index,or) {
          let oindex = this.branchs[index].or.indexOf(or)
          if (oindex > -1) {
            if (or.id) {
              this.deleteOrs.push(or.id+'')
            }
            this.branchs[index].or.splice(oindex,1);
          }
        },
        deleteCondition(condition) {
          let index = this.branchs.indexOf(condition)
          if (index > -1) {
            if (condition.id) {
              this.deleteBranches.push(condition.id+'')
            }
            this.branchs.splice(index,1);
            this.$emit('deleteJudge',condition)
          }
        },
        closeDialog(val) {
          if (!val) {
            this.showDialog = val
          }
        },
        initBind() {
          let that = this
          eventBus.$on('addRecognize', item => {
            if (that.showDrawer) {
              if (that.model.nodeId === item.rsId) {
                let has = that.triggerList.filter(t=>{
                  return t.rsId === item.rsId && t.nextSceneId === item.nextSceneId
                })
                //let index = that.triggerList.indexOf(has)
                if (has.length<=0) {
                  that.triggerList.push(item)
                }
              }
            }

          })
          eventBus.$on('addJudgeBranch',item=>{
            if (that.showDrawer) {
              if (that.model.nodeId === item.rsId) {
                //that.branchs.push(item)
                let branch = that.branchs.filter(b=>{
                  return b.rsId === item.rsId && b.nextSceneId === item.nextSceneId
                })
                //let index = that.branchs.indexOf(branch)
                if (branch.length <= 0) {
                  that.branchs.push(item)
                }
              }
            }

          })
          eventBus.$on('deleteRecognize',item=>{
            if (that.showDrawer) {
              if (item) {
                let trigger = that.triggerList.find(t=>{
                  return t.rsId === item.rsId && t.nextSceneId === item.nextSceneId
                })
                let index = that.triggerList.indexOf(trigger)
                if (index > -1) {
                  that.triggerList.splice(index,1)
                }
              }
            }
          })
          eventBus.$on('deleteJudge',item=>{
            if (that.showDrawer) {
              if (item) {
                let trigger = that.branchs.find(t=>{
                  return t.rsId === item.rsId && t.nextSceneId === item.nextSceneId
                })
                let index = that.branchs.indexOf(trigger)
                if (index > -1) {
                  that.branchs.splice(index,1)
                }
              }
            }
          })
        },
      },
      computed: {
        placementComputed() {
          return this.placement ? 'right' : 'left'
        }
      },
      created() {
        this.screenHeight.height = this.mountHeight(91+40)
        this.initBind()
      },
      destroyed() {
        eventBus.$off('addRecognize')
        eventBus.$off('addJudgeBranch')
        eventBus.$off('deleteRecognize')
        eventBus.$off('deleteJudge')
      },
      watch: {
         nodeShow: {
          deep: true,
          immediate: true,
           async handler(val) {
             if (val) {
               this.width = 500
               if (this.flowId) {
                 await this.initSelectData(this.flowId);
               }
             }
             this.showDrawer = val
          }
        },
        'model.id': {
          deep:true,
          immediate:true,
          async handler(val,oldValue) {
            this.sceneId = val
            if (this.nodeShow) {
              if (this.flowId) {
                await this.initSelectData(this.flowId);
              }
            }
            if (val !== oldValue) {
              //先上传
              if (this.showDrawer) {
                this.generatorUpdateData();
              }
              this.resetData()
              if(this.model){
                if (this.model.nodeData) {
                  this.generatorData(this.model.nodeData);
                } else {
                  console.log("load node data error !")
                }
              }
              let name = this.model.name;
              this.icon = this.model.icon
              this.label = this.model.label
              switch (name) {
                case '开始节点':
                  this.showType = [true,false,false,false]
                  this.label1 = '动作设置'
                  this.label2 = '识别设置'
                  this.tips = '连接节点，自动添加意图识别'
                  this.label3 = '信息采集槽位'
                  this.scene.rsType = '1'
                  break
                case '语音节点':
                  this.showType = [true,false,false,false]
                  this.label1 = '动作设置'
                  this.label2 = '识别设置'
                  this.tips = '连接节点，自动添加意图识别'
                  this.label3 = '信息采集槽位'
                  this.scene.rsType = '1'
                  break
                case 'DTMF节点':
                  this.showType = [false,true,false,false]
                  this.label1 = '交互设置'
                  this.label2 = '条件设置'
                  this.tips = '连接节点，自动添加条件分支'
                  this.label3 = '分支条件设置'
                  this.scene.rsType = '2'
                  break
                case 'HTTP节点':
                  this.showType = [false,false,true,false]
                  this.label1 = '交互设置'
                  this.label2 = '条件设置'
                  this.tips = '连接节点，自动添加条件分支'
                  this.label3 = '分支条件设置'
                  this.scene.rsType = '3'
                  break
                case '结束节点':
                  this.showType = [false,false,false,true]
                  this.label1 = '动作设置'
                  this.label2 = '结束设置'
                  this.tips = null
                  this.label3 = null
                  this.scene.rsType = '4'
                  break
                default:
                  break
              }
            }
          }
        },
        nodeList:{
           immediate:true,
          deep:true,
          handler(value) {
             this.nodes = this.nodeList
          }
        }
      }
    }
</script>

<style scoped lang="css">
.label_line{
  height: 35px;
  line-height: 35px;
  text-align: left;
  background-color: #D3DCE6;
  width: 100%;
  margin-left: -16px;
  margin-right: -16px;
  padding-left: 16px;
}
  .param{
    margin: 10px;
  }
  .paramTip{
    border-radius: 5px;
    border: 1px solid #2d8cf0;
    margin-right:25px;
    padding: 5px 10px;
    background-color: #97CBFF;
  }

  a{
    color: #3da8f1;
  }
  .el-input__inner{
    padding: 0 10px;
  }
.top-icon{
  width: 23px;
  height: 23px;
}
.tip-img {
  max-width: 13px;
  max-height: 13px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/flow/components/NodeDrawer.vue